import { Card, Typography } from 'src/components/common';
import { dicoverRocketTop } from 'src/assets/images';
import './discoverCardTop.scss';

function DiscoverCardTop() {
    return (
        <Card className="rocket-discoverTop">
            <img
                src={dicoverRocketTop}
                alt="roket"
                lang="lazy"
            />
            <div className="rocket-discoverTop__right">
                <Typography
                    as="h3"
                    variant="body-2"
                    fontWeight="semiBold"
                    className="rocket-discoverTop__right__heading"
                >
                    Explore Startup Programs by Top Incubators{' '}
                </Typography>
                <Typography
                    as="p"
                    variant="body-2"
                    fontWeight="semiBold"
                    className="rocket-discoverTop__right__para"
                >
                    Discover a curated list of startup programs launched by leading incubators, corporates, government and others to help founders at every stage{' '}
                </Typography>
            </div>
        </Card>
    )
}

export default DiscoverCardTop
